// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper___HmAt","container":"styles_container__261GE","title":"styles_title__mOBxG","description":"styles_description__3bNYF","link":"styles_link__1kaFj"};